export default "__VITE_ASSET__DYVSPwbO__"